import { computed } from 'vue'
import { useTheme } from 'vuetify'

export function useVuetify() {
  const theme = useTheme()
  const background = computed(() => theme.global.current.value.colors.background)
  const isDark = computed(() => theme.global.current.value.dark ? true : false)

  function toggleTheme() {
    theme.global.name.value = theme.global.current.value.dark ? 'light' : 'dark'
  }

  return {
    background,
    isDark,
    toggleTheme
  }
}
